import shield from 'assets/images/frontend/shield-exclamation-dkblue1.svg'
import whiteShield from 'assets/images/frontend/shield-exclamation-white.svg'

export default {
    shield,
    whiteShield,
}
